const triggers = [
  { icon: 'ri-line-chart-line', title: 'Компания быстро растёт', desc: 'Количество сотрудников увеличивается, процессы усложняются, нужны единые стандарты работы и обучения' },
  { icon: 'ri-user-star-line', title: 'Новые руководители', desc: 'Сотрудников повышают до управленцев, но у них нет навыков руководства — нужна программа развития лидеров' },
  { icon: 'ri-user-unfollow-line', title: 'Высокая текучесть', desc: 'Сотрудники уходят быстрее, чем компания успевает нанимать — обучение помогает удерживать и развивать людей' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Масштабирование продаж', desc: 'Нужно, чтобы все менеджеры работали по единым стандартам и показывали стабильно высокие результаты' },
  { icon: 'ri-building-line', title: 'Открытие филиалов', desc: 'Новые офисы в других городах — необходимо быстро обучить команды и сохранить качество работы' },
  { icon: 'ri-computer-line', title: 'Внедрение CRM или новых систем', desc: 'Сотрудникам нужно не просто показать кнопки, а изменить привычные процессы работы' },
  { icon: 'ri-user-add-line', title: 'Массовый наём', desc: 'Компания растёт на 30-50% в год — без системы обучения новички не успевают выйти на плановые показатели' },
  { icon: 'ri-archive-line', title: 'Подготовка кадрового резерва', desc: 'Ключевые сотрудники могут уйти, а замены нет — программа обучения готовит преемников заранее' },
  { icon: 'ri-rocket-2-line', title: 'Запуск новых продуктов', desc: 'Новый продукт требует новых компетенций — сотрудников нужно системно подготовить до выхода на рынок' },
  { icon: 'ri-emotion-line', title: 'Рост требований клиентов', desc: 'Клиенты становятся требовательнее, конкуренты предлагают лучше — нужен новый уровень сервиса и компетенций' },
];

export default function WhenCompanyNeedsProgram() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Когда компании нужна собственная программа обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Если вы узнаёте свою ситуацию в одном или нескольких пунктах — пора переходить от разовых тренингов к системному обучению
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {triggers.map((t, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${t.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm leading-snug">{t.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}